import type { IField } from '@app/dashboard/types/outerLayout/common';
import {
  CUSTOMER_DETAILS_TYPES,
  MULTIPLE_CUSTOMERS_FIELDS,
  SINGLE_PAYMENTS_FIELDS,
} from '@app/dashboard/constants/payment-links/single-payments';

import { formatDateAndTime } from '../../../../utils';

export const isFormHaveErrors = (fields: object): boolean => {
  const valid = Object.values(fields).some((field) => field.errorMsg);
  return valid;
};

export const formatPayload = ({
  fields,
  tags,
  customerType,
}: {
  fields: IField;
  tags: string[];
  customerType: string;
}) => {
  const tempResult: { [key: string]: any } = {};

  Object.keys(fields).forEach((key) => {
    tempResult[key] = fields[key].value;
  });

  if (tempResult?.[SINGLE_PAYMENTS_FIELDS.ALLOWED_COUNTRIES]) {
    tempResult[SINGLE_PAYMENTS_FIELDS.ALLOWED_COUNTRIES] = tempResult[
      SINGLE_PAYMENTS_FIELDS.ALLOWED_COUNTRIES
    ].map((country: { value: { iso: string } }) => country.value.iso);
  }

  if (
    tempResult?.[SINGLE_PAYMENTS_FIELDS.DATE] &&
    tempResult?.[SINGLE_PAYMENTS_FIELDS.TIME]
  ) {
    const date = new Date(tempResult[SINGLE_PAYMENTS_FIELDS.DATE].start);
    const time = tempResult[SINGLE_PAYMENTS_FIELDS.TIME];

    tempResult.expires_at = formatDateAndTime(date, time);
    delete tempResult[SINGLE_PAYMENTS_FIELDS.DATE];
    delete tempResult[SINGLE_PAYMENTS_FIELDS.TIME];
  }

  if (customerType === CUSTOMER_DETAILS_TYPES.MULTIPLE) {
    const numberOfPayments = tempResult?.[SINGLE_PAYMENTS_FIELDS.PAYMENT_LIMIT];

    tempResult[MULTIPLE_CUSTOMERS_FIELDS.IS_MULTIPLE] = true;

    if (tags.length) {
      tempResult[MULTIPLE_CUSTOMERS_FIELDS.SHARE_WITH] = tags;
    }

    if (!numberOfPayments) {
      tempResult[MULTIPLE_CUSTOMERS_FIELDS.IS_UNLIMITED] = true;
    }
  }

  return tempResult;
};

export const payloadToFormData = (payload: Record<string, any>) => {
  const formData = new FormData();

  for (const key in payload) {
    const value = payload[key];

    if ([undefined, null, ''].includes(value)) continue;

    if (key === MULTIPLE_CUSTOMERS_FIELDS.SHARE_WITH) {
      value.forEach((customer: string) => formData.append(key, customer));
      continue;
    }

    if (key === SINGLE_PAYMENTS_FIELDS.PAYMENT_METHODS) {
      value.forEach((method: string) => formData.append(key, method));
      continue;
    }

    if (key === SINGLE_PAYMENTS_FIELDS.ALLOWED_COUNTRIES) {
      formData.append(key, value.join(','));
      continue;
    }

    formData.append(key, value);
  }

  return formData;
};
